<template>
  <div class="row mx-0 px-3 py-4">
    <div class="input-group row pe-0">
      <div class="col-12 pe-0">
        <div
          class="d-flex pe-0 justify-content-between justify-content-md-start align-items-center mb-1"
        >
          <label class="size-12" for="">転職意向度</label>
          <span class="tag-thirdly size-10 ms-2">必須</span>
        </div>
        <div class="d-flex flex-column flex-md-row gap-md-3">
          <div class="bg-silver-primary d-flex align-items-center mb-3 px-3 py-0d625 rounded-3">
            <input
              id="willingness-1"
              v-model="additionalStore.willingness"
              class="input-primary form-check-input radio-primary-input w-1d5 h-1d5 me-2"
              type="radio"
              name="willingness"
              value="right_now"
              :checked="additionalStore.willingness == 'right_now'"
            />
            <label class="form-check-label size-12 ms-3" for="willingness-1">今すぐ</label>
          </div>
          <div class="bg-silver-primary d-flex align-items-center mb-3 px-3 py-0d625 rounded-3">
            <input
              id="willingness-2"
              v-model="additionalStore.willingness"
              class="input-primary form-check-input radio-primary-input w-1d5 h-1d5 me-2"
              type="radio"
              name="willingness"
              value="within_three_months"
              :checked="additionalStore.willingness == 'within_three_months'"
            />
            <label class="form-check-label size-12 ms-3" for="willingness-2">3ヶ月以内</label>
          </div>
          <div class="bg-silver-primary d-flex align-items-center mb-3 px-3 py-0d625 rounded-3">
            <input
              id="willingness-3"
              v-model="additionalStore.willingness"
              class="input-primary form-check-input radio-primary-input w-1d5 h-1d5 me-2"
              type="radio"
              name="willingness"
              value="within_six_months"
              :checked="additionalStore.willingness == 'within_six_months'"
            />
            <label class="form-check-label size-12 ms-3" for="willingness-3">半年以内</label>
          </div>
          <div class="bg-silver-primary d-flex align-items-center mb-3 px-3 py-0d625 rounded-3">
            <input
              id="willingness-4"
              v-model="additionalStore.willingness"
              class="input-primary form-check-input radio-primary-input w-1d5 h-1d5 me-2"
              type="radio"
              name="willingness"
              value="within_one_year"
              :checked="additionalStore.willingness == 'within_one_year'"
            />
            <label class="form-check-label size-12 ms-3" for="willingness-4">1年以内</label>
          </div>
          <div class="bg-silver-primary d-flex align-items-center mb-3 px-3 py-0d625 rounded-3">
            <input
              id="willingness-5"
              v-model="additionalStore.willingness"
              class="input-primary form-check-input radio-primary-input w-1d5 h-1d5 me-2"
              type="radio"
              name="willingness"
              value="have_chance"
              :checked="additionalStore.willingness == 'have_chance'"
            />
            <label class="form-check-label size-12 ms-3" for="willingness-5">
              機会があれば転職したい
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAdditionalStore } from '@/stores/resume-candidate/Additional.store';

const additionalStore = useAdditionalStore();
</script>
